<template>
  <div 
    :style="app.isRecorder ? 'height: 225px' : ''" 
    :class="app.allowChat ? 'chat' : (app.isTeacher() ? 'chat-off-teacher' : 'chat-off')"
  >
    <ChatHeader @roomSelected="selectRoom" />
    <ChatBody @roomSelected="selectRoom" />
    <ChatInput />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { getApp } from '../models/App';
import ChatBody from './ChatBody.vue';
import ChatHeader from './ChatHeader.vue';
import ChatInput from './ChatInput.vue';

const app = getApp();

const showChatList = ref(false);

const selectRoom = (id: string) => {
  app.currentChat = id;
  showChatList.value = false;
};
</script>

<style scoped>
div.chat {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  background: var(--color-chat-bg);
}

div.chat-off {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  background: black;
}

div.chat-off-teacher {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  background: var(--color-chat-bg);
  border: 3px solid red;
}

</style>
